/* eslint-disable max-len */
export default {
  header: '',
  item: '{{label}} ({{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}})',
  footer: '',
  seeAllOption: 'See all'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/instantsearch.js/es/widgets/menu-select/defaultTemplates.js
// module id = null
// module chunks = 